import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import SuritLogo from "../components/brand/SuritLogo";
import { cargarDatosAlta } from "../lib/planes";

// TEN.4 (1.4) -- a donde vuelve Stripe tras el pago de un ALTA NUEVA.
//
// 🔴 El alta se completa en el webhook, DESPUÉS de esta redirección, así que aquí la cuenta puede
//    no existir todavía. Esta página NO afirma que exista: dice qué va a pasar y a qué correo.
// 🔴 Tampoco afirma que el pago se confirmó. Y no nombra medios de pago: medido por la API de
//    Stripe en TEN.4, el checkout ofrece sólo tarjeta y Link (OXXO y transferencia apagados).
//    Si algún día se activan, llegarían aquí con una ficha SIN pagar y el alta esperaría al dinero.
// El correo lo guardó la landing en sessionStorage justo antes de ir a Stripe: no va en la URL
// (historial, logs) ni sale de un endpoint (que diría qué correos compraron). Si no está -- otro
// navegador, otra pestaña -- se dice lo mismo sin la dirección.
// ⚠️ COPY PENDIENTE DE APROBACIÓN (parada 3.5 de TEN.4).

function leerAlta() {
  try {
    return JSON.parse(sessionStorage.getItem("surit_alta") || "null");
  } catch (_) {
    return null;
  }
}

export default function Bienvenida() {
  const [alta] = useState(leerAlta);
  // El correo de contacto es UNA constante del backend (TEN.4). Si no llega, el párrafo de ayuda
  // no se pinta: un "escríbenos a" sin dirección es peor que no decirlo.
  const [contacto, setContacto] = useState(null);
  useEffect(() => {
    cargarDatosAlta().then((d) => setContacto(d?.contacto_email || null)).catch(() => setContacto(null));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-lg bg-white rounded-2xl border border-slate-200 shadow-card p-8" data-testid="bienvenida">
        <Link to="/" className="flex items-center w-fit"><SuritLogo size={42} tone="claro" rotulo label="Surit Clínicas" /></Link>
        <div className="mt-6 w-12 h-12 rounded-xl bg-emerald-50 text-emerald-600 grid place-items-center">
          <MailCheck className="w-6 h-6" />
        </div>
        <h1 className="mt-4 font-display text-2xl font-bold">Gracias por contratar Surit Clínicas</h1>
        <p className="mt-3 text-slate-700">
          Estamos dando de alta tu clínica{alta?.plan ? <> con el plan <strong>{alta.plan}</strong></> : null}.
          Cuando tu pago se confirme te llegará {alta?.email
            ? <>a <strong data-testid="bienvenida-email">{alta.email}</strong></>
            : "a tu correo"} un enlace para crear tu contraseña.
        </p>
        {contacto && (
          <p className="mt-3 text-sm text-slate-600" data-testid="bienvenida-ayuda">
            ¿El correo está mal escrito, o no te llega en 15 minutos? Escríbenos a{" "}
            <a href={`mailto:${contacto}`} className="underline">{contacto}</a> con el nombre de tu clínica y lo resolvemos.
            Revisa también tu carpeta de spam.
          </p>
        )}
        {alta?.sofi && (
          <p className="mt-3 text-sm text-slate-600" data-testid="bienvenida-whatsapp">
            La conexión del WhatsApp de tu clínica la hacemos contigo: cuando entres a tu panel verás cómo agendarla.
          </p>
        )}
      </div>
    </div>
  );
}
